
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.859","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 25860","d":"M15.858 2.071L7.929 10 0 2.071 2.071 0l5.858 5.858L13.787 0z","fill-rule":"evenodd"}})])
          )
        }
      }
    